<template>
  <div class="contenter">
    <div class="question_title">{{sort+'.'+questions.question}}<span style="color: red;">*</span></div>
    <div v-for="(item,index) in questions.result.split(';')" :key="index" @click="bindRadio(item)">
      <el-radio :label="item" :value="radio" border class="question_radio"></el-radio>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Question",
      data(){
          return{
            radio:''
          }
      },
      props:{
          //问卷
        questions:{
          type:Object
        },
        sort:{
          type:Number||String
        }
      },
      methods:{
        bindRadio(item){
          //防重复
          if(this.radio != item){
            this.radio = item
            this.$emit('selectRadio',item)
          }
        },
      }
    }
</script>

<style scoped>
  .contenter{
    width: 100%;
    height: 100%;
    font-size: .3rem;
  }
  .question_title{
    margin: .2rem 0;
    font-size: .32rem;
    font-weight: 700;
  }
  .question_radio{
    width: 100%;
    margin: 0.06rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Question.vue